import React, { Component } from 'react';
import { Form as ImportForm } from 'semantic-ui-react';
import excludeKeys from '../../../../../utils/excludeKeys';

class FormSelect extends Component {
  render() {
    return (
      <ImportForm.Select {...excludeKeys(this.props)} />
    );
  }
}

export default FormSelect;
